import { put } from "redux-saga/effects";
import { constant } from "../constant";
import Cookies from "js-cookie";
// workers

function* userLogOutAction() {
  localStorage.clear();
  localStorage.removeItem("persist:roots");
  localStorage.removeItem("roots");
  localStorage.removeItem("submission_id");
  localStorage.removeItem("instructor_id");
  localStorage.removeItem("token");
  Cookies.remove("token");
  const payload = {
    type: constant.LOGOUT_SUCCESS,
    loginStatus: false,
  };
  yield put(payload);
}

export { userLogOutAction };
